import { useQuery } from "@tanstack/react-query";

const useGetFreshVolunteerList = () => {
  const {
    refetch: getFreshVolunteerRefetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: getFreshVolunteerList = [],
  } = useQuery({
    queryKey: ["GetFreshVolunteerList"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-fresh-volunteer`
      );
      const data = await res.json();
      // console.log("fresh volunteer list ", data.data);
      return data.data;
    },
  });

  return {
    getFreshVolunteerRefetch,
    getFreshVolunteerList,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};

export default useGetFreshVolunteerList;
